import { errorHandler } from "./error.service";
import { http, URL } from "./http.service";

export const addIncomeService = async (bussinessUuid, data) => {
  try {
    let resp = await http.post(`${URL}/income/${bussinessUuid}/create`, data);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const getIncomeService = async (bussinessUuid,params = {}) => {
  try {
     const queryString = new URLSearchParams(params).toString();
    let resp = await http.get(`${URL}/income/${bussinessUuid}/get-income?${queryString}`);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const updateIncomeService = async (bussinessUuid, incomeUuid, data) => {
  try {
    let resp = await http.put(
      `${URL}/income/${bussinessUuid}/${incomeUuid}`,
      data
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const deleteIncomeService = async (bussinessUuid, incomeUuid) => {
  try {
    let resp = await http.delete(
      `${URL}/income/${bussinessUuid}/${incomeUuid}`
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
